// extracted by mini-css-extract-plugin
export default {"stickyToolbar":"Details_stickyToolbar__ErJW9"};